const serviceJson = {
    infor: {
        "banner": './images/service/banner.jpg',
        "mobBanner": './images/service/mob/banner.png',
        "title": '我们的服务',
        "tag": '心动而喜<br>满意而得',
        "btnText": '联系我们',
        "btnLink": '/contact-us',
    },
    text: {
        "title": "梦想是时代关键词。助力企业从每一个简单的想法开始，创造改变，创新服务，是喜得的目标。<br>当您为客户创造了喜与得，也就为企业自身创造了喜与得。",
        "section": [{
                "id": 1,
                "text": "现代服务业正快速进化，不断涌现的新技术使我们有机会为客户创造出更多惊喜，获得更多客户的满意，也为服务业本身带来更多价值。"
            },
            {
                "id": 2,
                "text": "越来越多“智慧的服务”出现在市场上，喜得认为，要真正赢得客户的感动与满意，在应用更多技术的同时，也需要更多用心的设计，两者平衡才体现真正的智慧，从而在市场中脱颖而出。"
            },
        ]
    },
    serviceList: {
        "title": '行业洞察&nbsp;&nbsp;&nbsp;&nbsp;创意设计&nbsp;&nbsp;&nbsp;&nbsp;技术创新',
        "content": {
            "title": '设计与实施',
            "list": [{
                "id": 1,
                "image": './images/service/list1.jpg',
                "mobImage": './images/service/mob/1.png',
                "title": '设计与实施',
                "texts": [{
                        "id": 1,
                        "str": '您与客户接触的物理空间，也是客户获得体验的空间，除去满足基本功能，它可以被充分的设计利用，来为客户创造多重体验，提升客户满意和喜悦的程度，同时加深品牌价值的传递。'
                    }, {
                        "id": 2,
                        "str": '您将创新的服务、科技、设计与艺术多维度结合，是喜得不断追求的方向，我们可以为您进行体验空间整体规划设计，使它成为服务的理想场所，能与人互动的智慧空间。'
                    }

                ],
            }, {
                "id": 2,
                "image": './images/service/list2_v2.png',
                "mobImage": './images/service/mob/2_v2.png',
                "title": '咨询与设计',
                "texts": [{
                        "id": 1,
                        "str": '我们可以协助您分析客户需求，深入探查整个服务流程的客户感受。'
                    }, {
                        "id": 2,
                        "str": '发现任何可以创造惊喜感动的时机，挖掘任何可以令客户满意的新元素。'
                    }

                ],
            }, {
                "id": 3,
                "image": './images/service/list3.jpg',
                "mobImage": './images/service/mob/3.png',
                "title": '设计与开发',
                "texts": [{
                        "id": 1,
                        "str": '将我们的技术理解与设计经验与您的创新理念相结合。'
                    }, {
                        "id": 2,
                        "str": '找寻合理的技术方式，并设计包含新技术应用的服务体系。'
                    }, {
                        "id": 3,
                        "str": '再汇聚不同的专业能力，定制开发新技术应用。'
                    }

                ],
            }, ]
        },
    },
}

export default serviceJson
